export default [
  {
    path: "/zrater",
    // name: "insurance.home",
    component: () => import("@/views/zrater/LayoutPage.vue"),
    meta: {
      title: "ZRater Portal",
    },
    children: [
      {
        path: "",
        name: "zrater.state",
        component: () => import("@/views/zrater/StartPage.vue"),
        meta: {
          title: "Select State",
        },
      },
      // {
      //   path: ":state",
      //   name: "zrater.form",
      //   component: () => import("@/views/zrater/SchemaStateForm.vue"),
      //   meta: {
      //     title: "Form Schema",
      //   },
      // },
      {
        path: ":state/customer",
        name: "zrater.form.customer",
        component: () => import("@/views/zrater/customer/PrimaryInfo.vue"),
        meta: {
          title: "Form Schema",
          step: 1,
        },
      },
      {
        path: ":state/customer/contact",
        name: "zrater.form.customer.contact",
        component: () => import("@/views/zrater/customer/ContactInfo.vue"),
        meta: {
          title: "Form Schema",
        },
      },
      {
        path: ":state/vehicles",
        name: "zrater.form.vehicles",
        component: () => import("@/views/zrater/vehicle/VehiclesForm.vue"),
        meta: {
          title: "Form Schema",
          step: 2,
        },
      },
      {
        path: ":state/drivers",
        name: "zrater.form.drivers",
        component: () => import("@/views/zrater/driver/DriversForm.vue"),
        meta: {
          title: "Form Schema",
          step: 3,
        },
      },
      {
        path: ":state/quote/additional",
        name: "zrater.form.additional",
        component: () => import("@/views/zrater/quote/AdditionalParams.vue"),
        meta: {
          title: "AdditionalParams",
          step: 4,
        },
      },
    ],
  },
];
